import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { WorkspaceMember, WorkspaceMemberIn } from "@/types/workspaceMembers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const useCreateWorkspaceMember = () => {
  const userToken = useUserToken();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation(
    (body: WorkspaceMemberIn): Promise<{ message: string } | WorkspaceMember> =>
      fetch(ENDPOINTS.workspace_members, {
        body: JSON.stringify(body),
        method: "POST",
        headers: jsonAuthHeaders(userToken),
      }).then((res) => res.json()),
    {
      onSuccess: (data) => {
        if ("message" in data) {
          displayErrorToast(data.message);
          return;
        }
        queryClient.invalidateQueries([ENDPOINTS.legacy_workspaces]);
        queryClient.invalidateQueries([ENDPOINTS.workspaces]);
        queryClient.invalidateQueries([ENDPOINTS.workspace_invites]);
        navigate(`/workspace/${data.workspace_id}/home`);
      },
    },
  );
};

export { useCreateWorkspaceMember };
